import { render, staticRenderFns } from "./VerificationCodeForm.vue?vue&type=template&id=20c9a144&scoped=true"
import script from "./VerificationCodeForm.vue?vue&type=script&lang=js"
export * from "./VerificationCodeForm.vue?vue&type=script&lang=js"
import style0 from "./VerificationCodeForm.vue?vue&type=style&index=0&id=20c9a144&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c9a144",
  null
  
)

/* custom blocks */
import block0 from "./VerificationCodeForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports